export function Masthead() {
  return (
    <header className="masthead">
      <div>
        <div className="kicker">Caderno de receitas · v1</div>
        <h1 className="title">
          Calculadora do <em>Pão</em>
        </h1>
      </div>
      <div className="masthead-meta">
        calcula misturas e custos
        <br />
        <b>biológico · artesanal · sem glúten</b>
      </div>
    </header>
  );
}
